import { Entity, Vertex } from '../../../../../types';

export default function convertVertexToEntity(vertex: Vertex): Entity {
  if (!vertex || !vertex.properties) {
    return {
      entityType: ['VERTEX'],
      entityClass: ['NOT_FOUND'],
      entityKey: '_NULL_',
      properties: {},
    };
  }
  return {
    entityClass: vertex.entity._class,
    entityKey: vertex.entity._key,
    entityType: vertex.entity._type || [],
    properties: {
      ...vertex.properties,
      ...vertex.entity,
    },
  };
}
